import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Setting } from '@common/enums';
import { FsDialogModule } from '@firestitch/dialog';
import { FsHtmlRendererModule } from '@firestitch/html-editor';

@Component({
  selector: 'app-app-call-out-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FsDialogModule,
    MatDialogModule,
    MatButton,
    FsHtmlRendererModule,
  ],
  templateUrl: './app-call-out-dialog.component.html',
  styleUrl: './app-call-out-dialog.component.scss'
})
export class AppCallOutDialogComponent {
  private _data = inject(MAT_DIALOG_DATA);


  public title = '';
  public content = null;
  public Setting = Setting;

  constructor() {
    this.title = this._data.title;
    this.content = this._data.content;
  }

}
